/* eslint-disable no-debugger */
import React, { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import { createSATContractResultObj, createSATParticipantsFromBatch } from '../utils/SATUtils';

import useSwimAThonResultData from '../../../state/swimAThon/swimAThonResult/UseSwimAThonResultData';
import useSwimAThonContractData from '../../../state/swimAThon/swimAThonContract/UseSwimAThonContractData';

import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import usePrizeData from "../../../state/prize/UsePrizeData";

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

const useClubSwimAThonParticipant = () => {
  const navigate = useNavigate();
  const { environmentVariableState, SAT_SUBMITTED_STATUS_ID, SAT_SAVED_STATUS_ID } = useEnvironmentVariableData();
  const { swimAThonContractState, putSwimAThonContract } = useSwimAThonContractData();
  const { swimAThonResultState, updateResultObj } = useSwimAThonResultData();
  const [modalState, setModalState] = useState(getInitialModalState())
  const [uiState, setUiState] = useState({ tryECommerceRedirect: false, tryRedirect: false, dupsFound: false, recsLoadedCount: 0 });
  const [jsonFileState, setJsonFileState] = useState(getInitialJSONFileState);
  const [batchDataState, setBatchDataState] = useState({ isLoaded: false, data: [] });
  const { prizeState } = usePrizeData();

  const FileUpload = () => {
    const hiddenFileInput = React.useRef(null);
    let fileReader;
    let fileType;

    const handleSelectFileClicked = (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      hiddenFileInput.current.click();
    };

    const handleFileRead = (event) => {
      const fileContent = fileReader.result;
      processFile(fileContent, fileType);
    };

    const handleFileChosen = (file) => {
      fileType = file.name.substring(file.name.length - 3);

      fileReader = new FileReader();
      fileReader.onloadend = handleFileRead;
      fileReader.readAsText(file);
    };

    return (
      <div className="row">
        <div className="col-xs-12">
          <PrimaryButton onClick={handleSelectFileClicked}>Select a File to Upload (*.csv)</PrimaryButton>
        </div>
        <input
          type='file'
          id='file'
          ref={hiddenFileInput}
          style={{ display: 'none' }}
          onChange={e => handleFileChosen(e.target.files[0])} />
      </div>
    );
  }

  const processFile = (fileContent, fileType) => {
    const isValidFileType = fileType.toUpperCase() === "CSV";
    const fileArray = fileContent.toString().replace(/\r\n/g, '\n').split('\n');
    let arrayIdx = 0;

    if (isValidFileType === true) {
    
      let dataArray = [];     
      let startLine = 0; 

      let startPosArrayIndex = 0

      for (const fileLine of fileArray) {
        if (fileLine.includes('Participant Name')) {
          startLine = startPosArrayIndex + 1;
        }
        startPosArrayIndex++;
      }

      for (const fileLine of fileArray) {
        if (fileLine.trim().length === 0) {
          continue;
        }

        if (arrayIdx >= startLine) {
          const lineArray = fileLine.split(',');

          if (lineArray[0].trim().length === 0) {
            continue;
          }

          const amountRaised = parseFloat(lineArray[1]);
          const minActivePrize = prizeState.data.filter(prize => prize.isActive)
            .reduce((min, prize) => 
              min === null || prize.prizeMinAmount < min.prizeMinAmount ? prize : min, null);

          if (amountRaised < minActivePrize.prizeMinAmount) {
            continue;
          }

          const filteredData = prizeState.data.filter(prize => prize.prizeMinAmount <= amountRaised  && prize.isActive === true);
          const highestPrizeIndex = filteredData.length -1;
          const highPrizeId = filteredData[highestPrizeIndex].satPrizeId;
          const highPrizeDescription = filteredData[highestPrizeIndex].description;

          let batchDataObj = {
            participantName: lineArray[0],
            amountRaised: amountRaised,
            satPrizeId: highPrizeId,
            satPrizeDescription: highPrizeDescription
          };

          dataArray.push(batchDataObj);          
        }
        arrayIdx++;
      }

      setBatchDataState({ isLoaded: true, data: dataArray });
    } else {
      setJsonFileState({
        ...jsonFileState,
        satParticipantDataContent: '',
        isValidFileType: isValidFileType
      });
    }
  };

  const onSaveClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const newSatContract = createSATContractResultObj(swimAThonResultState.satContract, JSON.parse(JSON.stringify(swimAThonResultState.objData)), SAT_SAVED_STATUS_ID);

    putSwimAThonContract(newSatContract.satContractId, newSatContract);
    setUiState({ ...uiState, tryRedirect: true });
  };

  const onSubmitClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState({
      ...modalState,
      displayPopup: true,
      contractDate: swimAThonResultState.satContract.satDate
        ? formatDate(swimAThonResultState.satContract.satDate)
        : Constants.BLANK_DATE_STRING
    });
  };

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.CLUB_SWIMATHON_RESULTS_DETAIL);
  };

  const onAddParticipant = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.CLUB_SWIMATHON_RESULTS_DETAIL_PRIZEWINNERS_DETAIL);
  };

  const onLoadParticipants = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
  }

  const onEditParticipant = (e, satParticipantId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.CLUB_SWIMATHON_RESULTS_DETAIL_PRIZEWINNERS_DETAIL, { state: { satParticipantId } });
  }

  const onDeleteParticipant = (e, satParticipantId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const newSatResultObj = JSON.parse(JSON.stringify(swimAThonResultState.objData));
    newSatResultObj.satParticipant = swimAThonResultState.objData.satParticipant.filter(x => x.satParticipantId !== satParticipantId);

    updateResultObj(newSatResultObj);
  };

  const onModalSubmitClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const newSatContract = createSATContractResultObj(swimAThonResultState.satContract, JSON.parse(JSON.stringify(swimAThonResultState.objData)), SAT_SUBMITTED_STATUS_ID);

    putSwimAThonContract(newSatContract.satContractId, newSatContract);
    setModalState(getInitialModalState());
    setUiState({ ...uiState, tryECommerceRedirect: true });
  };

  const onModalCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(getInitialModalState());
  };

  useEffect(() => {
    if (batchDataState.isLoaded) {
      const newResultObj = JSON.parse(JSON.stringify(swimAThonResultState.objData));

      const uploadedParticipantsObj = createSATParticipantsFromBatch(batchDataState.data, swimAThonResultState.objData.satResultId, newResultObj.satParticipant || []);
      newResultObj.satParticipant = uploadedParticipantsObj.data;

      setUiState({ ...uiState, dupsFound: uploadedParticipantsObj.dupsFound, recsLoadedCount: uploadedParticipantsObj.recsLoadedCount });

      updateResultObj(newResultObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchDataState]);

  useEffect(() => {
    if (swimAThonContractState.isSaved === true && uiState.tryRedirect === true) {
      navigate(NavLinks.CLUB_SWIMATHON_RESULTS, { state: { performGet: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swimAThonContractState, uiState.tryRedirect]);

  useEffect(() => {
    if (swimAThonContractState.isSaved === true && uiState.tryECommerceRedirect === true) {
      navigate(NavLinks.CLUB_SWIMATHON_RESULTS_PAYMENTS, { state: { performGet: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swimAThonContractState, uiState.tryECommerceRedirect]);

  function getInitialModalState() {
    return {
      modalTitle: 'Submit Results?',
      displayPopup: false,
      contractDate: ''
    };
  }

  function getInitialJSONFileState() {
    return {
      satParticipantDataContent: '',
      isValidFileType: true
    };
  }

  return {
    isLoading: environmentVariableState.isLoading,
    isSaving: swimAThonContractState.isSaving,
    swimAThonResultState,
    modalState,
    uiState,
    FileUpload,
    onSaveClicked,
    onSubmitClicked,
    onBackClicked,
    onAddParticipant,
    onEditParticipant,
    onDeleteParticipant,
    onModalSubmitClicked,
    onModalCancelClicked,
    onLoadParticipants
  };
};

export default useClubSwimAThonParticipant
